module.exports = __webpack_public_path__ + "static/media/1973.cd409e2a.svg";